import { ASSETS } from "@/data/site";
import { GALLERY_IMAGES } from "@/data/gallery";

export const NEWS_CATEGORIES = ["All", "Charity News", "Rider Stories", "Behind the Scenes"];

// TODO: verify with RDA — publication dates below are placeholders
export const NEWS_POSTS = [
  {
    id: 1,
    slug: "charity-trustees-required",
    title: "Charity Trustees Required — Could You Help Shape Our Future?",
    category: "Charity News",
    date: "2026-02-10",
    readingTime: "3 min read",
    author: "RDA Glasgow",
    coverImage: ASSETS.facilityExterior,
    coverAlt: "The RDA Glasgow centre in Summerston",
    inlineImage: GALLERY_IMAGES.volunteersGroup,
    inlineAlt: "A group of smiling RDA Glasgow volunteers",
    excerpt:
      "We're looking for enthusiastic new trustees to help govern RDA Glasgow and guide the future of therapeutic riding across Greater Glasgow.",
    body: [
      "RDA Glasgow is recruiting new trustees to join the small, dedicated group of people who govern our charity. Trustees play a vital role — setting our direction, safeguarding our riders and horses, and making sure we can keep providing therapeutic riding for years to come.",
      "You don't need to be an equestrian expert to make a real difference. We welcome people from all walks of life who share our passion for helping disabled people experience the benefits of horses.",
      { pullQuote: "Being a trustee is a chance to give your skills and see them change lives — one ride at a time." },
      "Skills we'd especially value include finance, fundraising, HR, legal, marketing, safeguarding, equestrian knowledge and disability sector experience. Above all, we're looking for people who care about our cause and can commit a little time to help us thrive.",
      "If this sounds like you, we'd love to hear from you. Get in touch and we'll tell you everything you need to know about the role and how to apply.",
    ],
  },
  {
    id: 2,
    slug: "meet-the-horses",
    title: "Meet the Horses Behind the Magic",
    category: "Behind the Scenes",
    date: "2026-01-15",
    readingTime: "4 min read",
    author: "RDA Glasgow",
    coverImage: ASSETS.horsesPaddock,
    coverAlt: "Horses grazing in the paddock at RDA Glasgow",
    inlineImage: GALLERY_IMAGES.poniesNuzzling,
    inlineAlt: "Two ponies nuzzling each other",
    excerpt:
      "Our gentle, patient horses and ponies are at the very heart of everything we do. Say hello to a few of the team.",
    body: [
      "Every session at RDA Glasgow depends on our wonderful horses and ponies. Carefully chosen for their calm temperaments, they're patient partners who help our riders feel safe, confident and free.",
      // TODO: verify horse names — Bramble, Willow and Angus are placeholders
      "There's Bramble, a steady pony who's a firm favourite with newer riders; Willow, gentle and endlessly patient; and Angus, whose calm presence puts everyone at ease.",
      { pullQuote: "A good RDA horse is worth their weight in gold — kind, unflappable, and quietly brilliant at their job." },
      "Caring for our horses is a big responsibility and a real joy. Feed, bedding, farrier visits and vet care all help keep them healthy and happy — and it's only possible thanks to the generosity of our supporters.",
      "Next time you visit, be sure to say hello. Our horses love a fuss — and they're the real stars of the show.",
    ],
  },
  {
    id: 3,
    slug: "a-day-at-the-centre",
    title: "A Day at the Centre: What a Session Looks Like",
    category: "Rider Stories",
    date: "2025-11-20",
    readingTime: "4 min read",
    author: "RDA Glasgow",
    coverImage: GALLERY_IMAGES.lessonOutdoors,
    coverAlt: "A rider taking an outdoor lesson at RDA Glasgow",
    inlineImage: ASSETS.volunteering,
    inlineAlt: "Volunteers supporting a rider in the indoor school",
    excerpt:
      "Ever wondered what a typical session is really like? Come with us for a walk through a morning at RDA Glasgow.",
    body: [
      "Mornings at the centre begin early. Volunteers arrive to muck out, groom and tack up, while the horses enjoy a calm start to the day. By the time our first riders arrive, everything is ready and the yard is buzzing with quiet anticipation.",
      "Each rider is welcomed by name and matched with their horse, coach and team of volunteers. A side-walker steadies and reassures, a leader guides the horse, and a qualified coach shapes the session around the rider's own goals — whether that's balance, confidence or simply the joy of moving with the horse.",
      { pullQuote: "You can see the moment it clicks — a smile, a straighter back, a burst of pride. That's what we're here for." },
      "Sessions are gentle but purposeful. There are exercises and games, moments of focus and plenty of laughter. Progress can be quiet and gradual, but over weeks and months it adds up to something remarkable.",
      "As the last rider heads home, the volunteers turn the horses out and tidy the yard. It's hard work — but ask anyone here and they'll tell you the same thing: there's nowhere they'd rather be.",
    ],
  },
];

export const getPostBySlug = (slug) => NEWS_POSTS.find((p) => p.slug === slug);

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
